import CommonAction from "./CommonAction";
import BaseReducer from "../../utilities/BaseReducer";
import environment from "environment";

const PREFS_KEY = "queuePrefs";

export default class CommonReducer extends BaseReducer {
  initialState = {
    currentView: this.getPersistedPrefs().currentView || this.getInitialView(),
    currentLanguage: this.getInitialLanguage(),
    selectedDocument: null,
    currentPosition: null,
    options: {
      sortBy: this.getPersistedPrefs().options?.sortBy || this.getInitialSortBy(),
      sortOrder:
        this.getPersistedPrefs().options?.sortOrder || this.getInitialSortOrder(),
      pageNumber: "1",
      pageSize: this.getPersistedPrefs().options?.pageSize || "50",
      search: null,
      updation_status:
        this.getPersistedPrefs().options?.updation_status || null,
      extraction_status:
        this.getPersistedPrefs().options?.extraction_status || [],
    },
  };

  getPersistedPrefs() {
    try {
      return JSON.parse(localStorage.getItem(PREFS_KEY)) || {};
    } catch (err) {
      return {};
    }
  }

  persistPrefs(state) {
    try {
      localStorage.setItem(
        PREFS_KEY,
        JSON.stringify({
          currentView: state.currentView,
          options: state.options,
        })
      );
    } catch (err) {
      // storage unavailable: preferences simply are not persisted
    }
  }

  getInitialView() {
    const env = environment.APP_ENVIRONMENT; 
    return (env === "alabusTesting" || env === "eponaDevelopment" || env === "eponaTesting" || env === "eponaProduction") ? "Grid" : "List";
  }

  getInitialLanguage() {
    const env = environment.APP_ENVIRONMENT;
    if (
      env === "eponaDevelopment" ||
      env === "eponaTesting" ||
      env === "eponaProduction"
    ) {
      return "French";
    }
    if (env === "alabusTesting") {
      return "English";
    }
    return "German";
  }

  getInitialSortBy() {
    // FIFO: oldest received invoice first, for all environments
    return "received_at";
  }

  getInitialSortOrder() {
    return "ASC";
  }

  [CommonAction.SET_CURRENT_VIEW](state, action) {
    const nextState = {
      ...state,
      currentView: action.payload,
    };
    this.persistPrefs(nextState);
    return nextState;
  }
  [CommonAction.SET_CURRENT_LANGUAGE](state, action) {
    return {
      ...state,
      currentLanguage: action.payload,
    };
  }

  [CommonAction.SET_PAGE_OPTIONS](state, action) {
    const nextState = {
      ...state,
      options: action.payload
    };
    this.persistPrefs(nextState);
    return nextState;
  }
  
  [CommonAction.SET_SELECTED_DOCUMENT](state, action) {
    return {
      ...state,
      selectedDocument: action.payload
    };
  }

  [CommonAction.SET_CURRENT_POSITION](state, action) {
    return {
      ...state,
      currentPosition: action.payload
    };
  }
}
